// Acrylix theme — site-wide JS
(function(){
  // Mobile nav toggle
  const btn = document.querySelector('[data-action="toggle-mobile-nav"]');
  const panel = document.querySelector('[data-mobile-panel]');
  if (btn && panel) {
    btn.addEventListener('click', () => {
      const hidden = panel.hasAttribute('hidden');
      if (hidden) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', String(hidden));
    });
  }

  // Cart count updates after add-to-cart fetches
  window.updateCartCount = async function() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        if (el.classList.contains('cart-count')) {
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
    } catch (e) { console.warn('cart fetch failed', e); }
  };

  // Add-to-cart forms
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[data-add-to-cart]')) return;
    e.preventDefault();
    const fd = new FormData(form);
    const btn = form.querySelector('[type="submit"]');
    const orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
      if (!res.ok) throw new Error(await res.text());
      await window.updateCartCount();
      if (btn) btn.textContent = 'Added ✓';
      setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = orig; } }, 1200);
      // Optionally redirect to cart
      if (form.dataset.redirect === 'cart') location.href = '/cart';
    } catch (err) {
      console.error(err);
      if (btn) { btn.disabled = false; btn.textContent = orig; }
      alert('Could not add to cart. Please try again.');
    }
  });

  // Product variant picker — swatches + size + thickness
  document.querySelectorAll('[data-variant-picker]').forEach(root => {
    const variants = JSON.parse(root.dataset.variants || '[]');
    const optionNames = JSON.parse(root.dataset.optionNames || '[]');
    const selectedOpts = optionNames.map((_, i) => root.dataset['default' + i] || (variants[0] && variants[0].options[i]));
    const update = () => {
      // Find matching variant
      const match = variants.find(v => v.options.every((o, i) => o === selectedOpts[i]));
      const idInput = root.querySelector('input[name="id"]');
      const priceEl = root.querySelector('[data-variant-price]');
      const submitBtn = root.closest('form').querySelector('[type="submit"]');
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = match.priceFormatted;
        if (submitBtn) {
          submitBtn.disabled = !match.available;
          submitBtn.textContent = match.available
            ? (submitBtn.dataset.labelAvailable || 'Add to cart')
            : 'Sold out';
        }
      } else {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
      }
      // Update selected UI
      root.querySelectorAll('[data-option-button]').forEach(b => {
        const i = +b.dataset.optionIndex;
        const v = b.dataset.optionValue;
        b.setAttribute('aria-pressed', selectedOpts[i] === v);
      });
    };
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-option-button]');
      if (!b) return;
      const i = +b.dataset.optionIndex;
      selectedOpts[i] = b.dataset.optionValue;
      update();
    });
    update();
  });

  // Quantity steppers
  document.addEventListener('click', (e) => {
    const stepper = e.target.closest('[data-qty]');
    if (!stepper) return;
    const input = stepper.parentElement.querySelector('input[type="number"], input[name="quantity"]');
    if (!input) return;
    const delta = stepper.dataset.qty === '+' ? 1 : -1;
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
